// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"22a052cb","224":"7812b2f1","258":"8596c8c7","458":"99db6f55","911":"f0b77d94"}[chunkId] + ".chunk.js";
};